






















































































import { mixins, Component } from 'nuxt-property-decorator';
import clickOutside from '@/directives/click_outside';
import UniversalSearchMixin from '@/components/common/UniversalSearch/UniversalSearchMixin';
import UniversalSearchHistoryMixin from '@/components/common/UniversalSearch/UniversalSearchHistoryMixin';
import UniversalSearchPlaceholder from '@/components/common/UniversalSearch/UniversalSearchPlaceholder.vue';
import UniversalSearchResults from '@/components/common/UniversalSearch/UniversalSearchResults/UniversalSearchResults.vue';
import UniversalSearchSuggestions from '@/components/common/UniversalSearch/UniversalSearchSuggestions.vue';
import UniversalSearchHistory from '@/components/common/UniversalSearch/UniversalSearchHistory.vue';
import UniversalSearchResultsLoader from '@/components/common/UniversalSearch/UniversalSearchResults/UniversalSearchResultsLoader.vue';
import DualRingLoader from '@/components/common/DualRingLoader.vue';
import SearchIcon from '@/components/common/UniversalSearch/images/search.vue.svg';
import ArrowIcon from '@/components/common/UniversalSearch/images/arrow-right.vue.svg';
import { buildSearchItemData } from '@/components/common/UniversalSearch/utils';
import { redirectTo } from '@/components/utils/browser/url';
import ScrollLock from '@/components/utils/browser/scrollLock';
import ProgressBar from '@/components/utils/browser/nuxtLoadingProgressBar';
import type { UniversalSearchResult } from '@/components/common/UniversalSearch/types';

@Component<UniversalSearch>({
  directives: {
    'click-outside': clickOutside,
  },
  components: {
    DualRingLoader,
    SearchIcon,
    ArrowIcon,
    UniversalSearchPlaceholder,
    UniversalSearchResults,
    UniversalSearchSuggestions,
    UniversalSearchHistory,
    UniversalSearchResultsLoader,
  },
})
export default class UniversalSearch extends mixins(UniversalSearchMixin, UniversalSearchHistoryMixin) {
  isExpandable: boolean = false;
  searchTerm: string = '';

  handleBrowse() {
    this.$analytics.logEvent('search__more__click', {
      query: this.query,
      queryId: this.queryId,
      version: 'v1',
    });
    this.handleCollapse();
  }

  handleSuggestionSelect(suggestion: string) {
    this.searchTerm = suggestion;
  }

  handleExpand() {
    this.isExpandable = true;

    // Focus on input on mobile when open
    if (this.$breakpoint.xs) {
      this.$nextTick(() => {
        (this.$refs.input as HTMLInputElement)?.focus();
      });
    }

    ScrollLock.enable();
    ProgressBar.hide();
  }

  handleCollapse() {
    if (!this.isExpandable) return;
    this.isExpandable = false;
    ScrollLock.disable();
    ProgressBar.show();
  }

  async handleOpen(item: UniversalSearchResult, isFromHistory: boolean) {
    const searchItemData = buildSearchItemData(item);

    // Before open the external resourse app should wait for history item creation
    if (searchItemData?.isExternal) {
      await this.createHistoryItem(this.searchTerm, item);
    } else {
      this.createHistoryItem(this.searchTerm, item);
    }

    if (searchItemData) {
      const endSearchSession = () => {
        this.handleCollapse();
        this.searchTerm = '';
      };

      const eventName = isFromHistory ? 'search__history__click' : 'search__results__click';
      this.$analytics.logEvent(eventName, {
        query: this.query,
        queryId: this.queryId,
        section: searchItemData.category,
        data: searchItemData,
        version: 'v1',
      });

      if (searchItemData.isExternal) {
        redirectTo(searchItemData.link);
      } else {
        // Success + failure callbacks, because $router.push isn't async
        this.$router.push(searchItemData.link, endSearchSession, endSearchSession);
      }
    }
  }

  handleClear() {
    this.searchTerm = '';
    (this.$refs.input as HTMLInputElement)?.focus();
  }

  handleHistoryRemove(item: { queryId: string }) {
    this.destroyHistoryItem(item.queryId);
  }

  handleEscape(event: KeyboardEvent) {
    this.handleCollapse();
    (this.$refs.input as HTMLInputElement)?.blur();
  }

  beforeDestroy() {
    this.handleCollapse();
  }
}
